export default [
  {
    value: 'id',
    text: '#',
    type: 'number',
    width: 40,
    description: ''
  },
  {
    value: 'email',
    text: 'Email',
    type: 'string',
    description: ''
  },
  {
    value: 'phone',
    text: 'Телефон',
    type: 'string',
    description: ''
  },
  {
    value: 'createdAt',
    text: 'Создано',
    type: 'date',
    description: ''
  },
  {
    value: 'updatedAt',
    text: 'Изменено',
    type: 'date',
    description: ''
  },
  {
    value: 'actions',
    text: 'Действия',
    align: 'end',
    type: 'actions',
    sortable: false,
    description: ''
  }
]
